function passwordNotSaved() {
	document.getElementById("l_p_1").style.color = '#e17068';
	document.getElementById("l_p_1").style.opacity = '1';
	document.getElementById("l_p_2").style.color = '#e17068';
	document.getElementById("l_p_2").style.opacity = '1';
}

function passwordSaved() {
	document.getElementById("forgotten").innerHTML = 'Wachtwoord gewijzigd';

    var elem = document.getElementById("form_regAdv");
	elem.parentNode.removeChild(elem);

	console.log ("JOJO");
}
